/* eslint-disable react/prop-types */ // TODO: add props
import Select from 'react-select';

const Editor = ({ checklistItems, annotation, onChange, onSubmit }) => {
  const { geometry } = annotation;
  if (!geometry) {
    return null;
  }

  const checklistSelectOptions = checklistItems
    .map((item) => ({
      value: item.get('serial'),
      label: `${item.get('serial')} : ${item
        .get('description')
        .substring(0, 40)}...`,
    }))
    .toArray();

  return (
    <div
      style={{
        position: 'absolute',
        left: `${geometry.x}%`,
        top: `${geometry.y + geometry.height}%`,
        width: '400px',
      }}
    >
      <Select
        options={checklistSelectOptions}
        value={annotation.data ? annotation.data.checklistItemSerial : null}
        onChange={({ value }) => {
          onChange({
            ...annotation,
            data: {
              ...annotation.data,
              checklistItemSerial: value,
            },
          });
        }}
      />
      <button className="button-legacy" onClick={onSubmit}>
        Ok
      </button>
    </div>
  );
};

export default Editor;
